import { FILTER_TYPE } from 'components/FiltersBlock/types';

export const STATUS_FILTER = {
  label: 'Статус',
  name: 'status',
  type: FILTER_TYPE.SELECT,
  showSearch: true,
  apiUrl: '/api/issues/statuses/?page=1',
};

export const STATUS_SCS_FILTER = (structureId?: number) => {
  return {
    label: 'Статус',
    name: 'status',
    type: FILTER_TYPE.SELECT,
    showSearch: true,
    apiUrl: structureId
      ? `/api/standards/structures/statuses/?page=1&view_type=SCS&structure=${structureId}`
      : '/api/standards/structures/statuses/?page=1&view_type=SCS',
  };
};

export const STATUS_WORKPLACE_FILTER = (structureId: number) => {
  return {
    label: 'Статус',
    name: 'status',
    type: FILTER_TYPE.SELECT,
    apiUrl: structureId
      ? `/api/standards/structures/statuses/?page=1&view_type=SCS&work_place=ON_REVIEW&structure=${structureId}`
      : '/api/standards/structures/statuses/?page=1&view_type=SCS&work_place=ON_REVIEW',
  };
};

export const STATUS_ENGINEERING_FILTER = {
  label: 'Статус',
  name: 'status',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/standards/structures/engineering_statuses/',
};
